/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { regular } from "cms/icons/index";
import { ReactComponent as CloseIcon } from "assets/images/icons/components/close.svg";
import { ReactComponent as EditIcon } from "assets/images/icons/components/edit.svg";

const faFile = regular?.faFile;
const faEnvelope = regular?.faEnvelope;
const faPlug = regular?.faPlug;
const faArrowUpRightFromSquare = regular?.faArrowUpRightFromSquare;

const DefaultDisplayComponent = (props) => {
    const { link, onChange, onRemove } = props || {};

    const link_type = link?.link_type;
    const text = link?.text;
    const url = link?.url;

    const isMailTo = link_type === "mailto";
    const isIntegration = link_type === "integration";
    const isInternal = link_type === "internal";
    const isExternal = link_type === "external";
    
    const changeLink = () => {
        onChange(link);
    };

    const removeLink = () => {
        onRemove(link);
    };

    return (
        <Fragment>
            {link && (
                <>
                    <div className="link-selector-display-wrapper">
                        <div className="link-selector-display-container" onClick={() => onChange(link)}>
                            <div className="link-selector-icon-container">
                                <div>
                                    {isInternal && <FontAwesomeIcon icon={faFile} />}
                                    {isExternal && <FontAwesomeIcon icon={faArrowUpRightFromSquare} />}
                                    {isMailTo && <FontAwesomeIcon icon={faEnvelope} />}
                                    {isIntegration && <FontAwesomeIcon icon={faPlug} />}
                                </div>
                            </div>
                            <div className="link-selector-text-container">
                                <div className="link-selector-text">{text}</div>
                                <div className="link-selector-url">{url}</div>
                            </div>
                        </div>
                        <div className="link-selector-infobox-container">
                            <div onClick={changeLink}>
                                <EditIcon />
                            </div>
                            <div onClick={removeLink}>
                                <CloseIcon />
                            </div>
                        </div>
                    </div>
                </>
            )}
        </Fragment>
    );
};

export { DefaultDisplayComponent };
